import React, { useState, useEffect, useRef } from "react";
import { getUserEntity, signOutSubmit, switchEntity } from "../../../redux/features/auth/authService";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from '../index.module.css';
import ToggleIcon from '../../../assets/images/icons/toggle_icon.png';
import { incrementEntityVersion, selectUserDetails, selectUserEntityDetails } from "../../../redux/features/auth/authSlice";
import DefaultImage from '../../../assets/images/icons/blank_profile_pic.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faArrowRight, faList, faUser } from "@fortawesome/free-solid-svg-icons"
import LogoutIcont from '../../../assets/images/icons/logout_icon.png';
import { getActiveCertificateEntities } from "../../../redux/features/certificateEntity/certificateEntityService";
import { selectActiveCertificateList } from "../../../redux/features/certificateEntity/certificateEntitySlice";
import { showToast } from "../../ToastMsg";
import { BeatLoader } from "react-spinners";

const EntityAdminHeader = ({ toggleSidebar }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { pathname } = location;
    const { roleName, details } = useSelector(selectUserDetails);
    const { status, data: activeCertificateEntities } = useSelector(selectActiveCertificateList);
    const { user_certificate_entity } = useSelector(selectUserEntityDetails);

    const [isOpen, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const entityDropdownRef = useRef(null);

    const role = pathname.split('/')[1];
    const splitAfterRole = pathname.split(`/${role}/`)[1];
    const pathSegments = splitAfterRole ? splitAfterRole.split('/') : [];
    const displaySegments = pathSegments.filter(segment => isNaN(segment)).slice(0, -1);

    const [isMobileView, setIsMobileView] = useState(false);
    const basePath =
        "/" + location.pathname.split("/").filter(Boolean).slice(0, 2).join("/");

    useEffect(() => {
        dispatch(getActiveCertificateEntities());
    }, [dispatch]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 430);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        try {
            await dispatch(signOutSubmit()).unwrap();
        } catch (error) {
            console.error("Logout failed:", error);
        } finally {
            navigate("/login", { replace: true });
        }
    };

    const createLinkPath = (index) => {
        const basePath = `/${role}/`;
        const dynamicPath = pathSegments.slice(0, index + 1).join('/');
        return `${basePath}${dynamicPath}`;
    };

    const getActivityLogs = () => {
        if (roleName === 'admin') {
            navigate('/admin/my-activities');
        }
        if (roleName === 'entity_admin') {
            navigate('/entity_admin/my-activities');
        }
        if (roleName === 'certificate_issuer') {
            navigate('/issuer/my-activities');
        }
        if (roleName === 'exam_controller') {
            navigate('/controller/my-activities');
        }
        if (roleName === 'auditor') {
            navigate('/auditor/my-activities');
        }
        if (roleName === 'chairman') {
            navigate('/chairman/profile');
        }
    };

    const [isEntityOpen, setIsEntityOpen] = useState(false);
    const [isEntityLoading, setEntityLoading] = useState(false);

    const toggleDropdown = () => setIsEntityOpen((prev) => !prev);

    const onOptionClicked = async (value) => {
        setEntityLoading(true);
        setIsEntityOpen(false);
        try {
            await dispatch(
                switchEntity({ entity_token: value, prev_entity_token: user_certificate_entity })
            ).unwrap();
            await dispatch(
                getUserEntity()
            ).unwrap();
            setEntityLoading(false);
            dispatch(incrementEntityVersion());
            navigate(basePath);
        } catch (error) {
            showToast('error', error.message);
            setEntityLoading(false);
        }
    };

    const handleClickOutside = (event) => {
        if (entityDropdownRef.current && !entityDropdownRef.current.contains(event.target)) {
            setIsEntityOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getProfile = () => {
        if (roleName === 'entity_admin') {
            navigate('/entity_admin/my-profile');
        }
        if (roleName === 'certificate_issuer') {
            navigate('/issuer/my-profile');
        }
        if (roleName === 'exam_controller') {
            navigate('/controller/my-profile');
        }
        if (roleName === 'auditor') {
            navigate('/auditor/my-profile');
        }
        if (roleName === 'viewer') {
            navigate('/user/my-profile');
        }
    };

    return (
        <header className={styles.header}>
            <div className={styles.leftSec}>
                <div className={styles.toggleHeader}>
                    <img
                        src={ToggleIcon}
                        className={styles.toggleBtn}
                        alt="toggle"
                        onClick={toggleSidebar}
                    />
                </div>
                <div>
                    <div style={{ width: '100px', position: 'relative' }} ref={entityDropdownRef}>
                        <button
                            onClick={toggleDropdown}
                            className={styles.dropdownButton}
                            style={{ width: '100%', padding: '10px', textAlign: 'left' }}
                            disabled={details?.user_certificate_entities.length < 2}
                        >
                            {isEntityLoading ? <BeatLoader color='#474747' /> : user_certificate_entity}
                            <span style={{ float: 'right' }}>
                                {isEntityOpen ? '▲' : '▼'}
                            </span>
                        </button>

                        {isEntityOpen && (
                            <ul className={styles.entityDropdownMenu}>
                                {details?.user_certificate_entities
                                    ?.filter((entity) => entity?.status === true)
                                    .map((entity) => (
                                        <li
                                            key={entity.id}
                                            onClick={() => onOptionClicked(entity?.certificate_entity?.code)}
                                            style={{ padding: '10px', cursor: 'pointer' }}
                                            className={
                                                user_certificate_entity === entity?.certificate_entity?.code
                                                    ? styles.selectedValue
                                                    : ''
                                            }
                                        >
                                            {entity?.certificate_entity?.code}
                                        </li>
                                    ))}
                            </ul>
                        )}
                    </div>

                </div>
            </div>
            <div
                className={styles.profileSec}
                onClick={() => setOpen(!isOpen)}
                ref={dropdownRef}
            >
                <img
                    src={details?.image_url ? details?.image_url : DefaultImage}
                    className={styles.imageSec}
                />
                {!isMobileView ? (
                    <div className={styles.detailsSec}>
                        <p className={styles.profileName}>{details?.full_name}</p>
                        <p className={styles.profileRole}>
                            {roleName
                                ?.split("_")
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                .join(" ")
                            }
                        </p>
                    </div>
                ) : null}
                <FontAwesomeIcon icon={faAngleDown} color="#9FA6B2" />
                {isOpen ? (
                    <ul className={styles.dropdownMenu}>
                        {roleName !== 'viewer' && <li className={styles.dropdownItem} onClick={getActivityLogs}>
                            <FontAwesomeIcon icon={faList} width={24} /> My Activity
                        </li>}
                        <li className={styles.dropdownItem} onClick={getProfile}>
                            <FontAwesomeIcon icon={faUser} width={24} /> My Profile
                        </li>
                        <li onClick={handleLogout} className={styles.dropdownItem}>
                            <FontAwesomeIcon icon={faArrowRight} width={24} />Logout
                        </li>
                    </ul>
                ) : null}
            </div>
        </header>
    );
};

export default EntityAdminHeader;